import React from "react";
import { HiUsers } from "react-icons/hi";
import { ImTree } from "react-icons/im";

const CourseCard = ({ cardData, currentCard, setCurrentCard }) => {
  return (
    <div
      className={`relative w-[360px] lg:w-[30%] mx-2 ${
        currentCard === cardData?.heading
          ? "bg-white shadow-[12px_12px_0_0] border shadow-[#3b6333]"
          : "bg-richblack-800"
      } text-richblack-25 h-[300px] box-border cursor-pointer rounded-2xl overflow-hidden group`}
      onClick={() => setCurrentCard(cardData?.heading)}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
        style={{ backgroundImage: `url(${cardData.imageUrl})` }}
      ></div>

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black transition-opacity duration-300 opacity-0 group-hover:opacity-40"
      ></div>

      {/* Sliding Animation */}
      <div
        className="absolute inset-0 bg-richblack-800 transition-transform duration-500 transform -translate-y-full group-hover:translate-y-0 opacity-70"
      ></div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-between my-8 items-center text-center text-[#D1AF14] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
        <div className="font-bold text-[30px]">{cardData.heading}</div>
        <div className="text-richblack-5 mt-2">{cardData.description}</div>
        <div className="flex justify-between w-full px-6 py-3 font-medium">
          {/* Level */}
        
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
